import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./reviewsEmptyState.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import * as kagekiri from 'kagekiri';
import { selectIsGuestUser, userStore } from '~/modules/stores/userStore';
import { images } from '~/modules/utilities/assetUtilities';
class ReviewsEmptyState extends LightningElement {
  constructor(...args) {
    super(...args);
    this.labels = void 0;
    this.filtersApplied = void 0;
    this.listingId = void 0;
    this.userAuthenticated = false;
    this.showWriteReviewModal = false;
    this.shouldAutoFocusWriteReviewModal = false;
    this.imageUrl = images.errorEmptyState;
  }
  setUserAuthenticated(isGuestUser) {
    this.userAuthenticated = !isGuestUser;
  }
  get loadingImageWidth() {
    return getComputedStyle(this.template.host).getPropertyValue('--loading-image-width');
  }
  get loadingImageHeight() {
    return getComputedStyle(this.template.host).getPropertyValue('--loading-image-height');
  }
  get writeReviewButtonRef() {
    return kagekiri.querySelector('.write-review-btn');
  }
  handleWriteReviewButtonClick(event) {
    if (!this.userAuthenticated) {
      return window.SFIDWidget.login();
    }
    this.shouldAutoFocusWriteReviewModal = event.detail !== 0;
    return this.showWriteReviewModal = true;
  }
  toggleWriteReviewModal() {
    this.showWriteReviewModal = !this.showWriteReviewModal;
    this.writeReviewButtonRef.focus();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ReviewsEmptyState, {
  publicProps: {
    labels: {
      config: 0
    },
    filtersApplied: {
      config: 0
    },
    listingId: {
      config: 0
    }
  },
  wire: {
    setUserAuthenticated: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectIsGuestUser
        };
      }
    }
  },
  fields: ["userAuthenticated", "showWriteReviewModal", "shouldAutoFocusWriteReviewModal", "imageUrl"]
});
const __lwc_component_class_internal = _registerComponent(ReviewsEmptyState, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;